enum AttachmentType {
	Undefined = 0,

	//drivers
	DriverLicense = 100,

	//holders
	ProofOfEmployment = 200,

	//permits
	ParkingSpaceAuthorization = 300,
	ConstructionServiceAuthorization,
	NannyServiceAuthorization,
	MedicalServiceAuthorization,
	StudentInscription,

	//residencies
	ProofOfResidency = 400,
	InternetBill,
	GasBill,
	WaterBill,
	ElectricBill,
	TaxNotice,
	TaxAssessment,
	RentalAgreement,

	//vehicles
	VehicleRegistration = 500,
	FamilyVehicle,
	BusinessVehicle,
	OverweightVehicle,

	//Payments
	BankTransferId = 600,

	//Misc
	ParkingGeometryMap = 700,
	MiscellaneousDocument
}

export default AttachmentType;
